import React from "react";
import { Box, FormControlLabel, Paper, Stack, Switch } from "@mui/material";
import { useIntl } from "react-intl";
import RevaText from "components/common/RevaText";
import BrandingColorPicker from "./BrandingColorPicker";
import { FULL_COLOR_FIELDS } from "./branding-defaults";

const BrandingColorPanel = ({ form, onPatch }) => {
  const intl = useIntl();

  return (
    <Paper variant="outlined" sx={{ p: 2.5 }}>
      <RevaText variant="h6" sx={{ mb: 2 }}>
        {intl.formatMessage({ id: "gestion.branding.colors.title" })}
      </RevaText>
      <FormControlLabel
        sx={{ mb: 2, display: "flex" }}
        control={
          <Switch
            checked={Boolean(form.loginLogoEnabled)}
            onChange={(event) => onPatch({ loginLogoEnabled: event.target.checked })}
          />
        }
        label={intl.formatMessage({ id: "gestion.branding.logoVisibility" })}
      />
      <Stack spacing={0}>
        {FULL_COLOR_FIELDS.map((field) => (
          <BrandingColorPicker
            key={field.key}
            labelId={field.labelId}
            value={form[field.key] || ""}
            onChange={(hex) => onPatch({ [field.key]: hex })}
            compact
          />
        ))}
      </Stack>
    </Paper>
  );
};

export default BrandingColorPanel;
